export default "__VITE_ASSET__yu5Qu4Sb__"